/* ============================================================
 * Contact Us Contact Section
 * ============================================================ */

(function () {
    'use strict';

    function initReveal(scope = document) {
        const wrappers = scope.querySelectorAll(
            '.contact-us-contact-section__image-wrap:not([data-reveal-initialized])'
        );

        wrappers.forEach((wrapper) => {
            wrapper.dataset.revealInitialized = 'true';

            wrapper.querySelectorAll('img').forEach((image) => {
                const markLoaded = () => {
                    image.classList.add('is-loaded');
                };

                if (image.complete && image.naturalWidth > 0) {
                    markLoaded();
                } else {
                    image.addEventListener('load', markLoaded, {
                        once: true
                    });
                }
            });

            const observer = new IntersectionObserver(
                ([entry]) => {
                    if (!entry.isIntersecting) return;

                    wrapper.classList.add('is-in-view');
                    observer.unobserve(wrapper);
                },
                {
                    threshold: 0.15,
                    rootMargin: '0px 0px -10% 0px'
                }
            );

            observer.observe(wrapper);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener(
            'DOMContentLoaded',
            () => initReveal(),
            { once: true }
        );
    } else {
        initReveal();
    }

    document.addEventListener('shopify:section:load', (event) => {
        initReveal(event.target);
    });
})();